import React from 'react';
import { LinkPill } from '../LinkPill';
import { createMarkdownComponents, type MarkdownComponentsWithText, type MarkdownTextRenderer } from '../markdown/primitives';
import { ideaCardMarkdownTable } from '../markdown/tokens';
import type { MarkdownDensity } from './presentation';
import { getIdeaCardMarkdownTypography } from './typography';

interface MarkdownIdeaComponentOptions {
  density?: MarkdownDensity;
}

export const getMarkdownIdeaComponents = (
  renderTextWithCitations?: MarkdownTextRenderer,
  t?: (key: string) => string,
  { density = 'compact' }: MarkdownIdeaComponentOptions = {}
): MarkdownComponentsWithText =>
  createMarkdownComponents({
    typography: getIdeaCardMarkdownTypography(density),
    table: ideaCardMarkdownTable,
    t,
    renderTextWithCitations,
    renderLink: (props) => <LinkPill {...props} className="mt-1" />,
  });
